import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Input,
  Form,
  FormFeedback,
} from "reactstrap";
import Select from "react-select";
import {
  getProfilescat,
  postCompany,
  putCompany,
  getCompanies,
  putReseller,
  postReseller,
} from "../../helpers/backend_helper";
import { getStorageUser } from "../../helpers/api_helper";
import { Alert, ToastHelper } from "../../helpers/alerts/alertHelper";
import * as Yup from "yup";
import { useFormik } from "formik";

const AddUpdModal = ({ modal, setModal, items, setItems, setItem, item }) => {
  const [selects, setSelects] = useState({
    profiles: [{ id: 0, name: "" }],
    companies: [{ id: 0, name: "" }],
  });
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const authUser = getStorageUser();
  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: item,
    validationSchema: Yup.object({
      name: Yup.string().nullable().required("Requerido").min(1),
      user_name: Yup.string().nullable().required("Requerido").min(1),
      user_email: Yup.string().nullable().required("Requerido").email("No es un email válido"),
    }),
    onSubmit: async (values) => {
		setLoading(true);
		try {
			await save(values);
			handleClose();
      		validation.resetForm();
		} catch (error) {}
		setLoading(false);
    },
  });

  const save = async (data) => {
    setErrors([]);
	let response = modal.update ? await putReseller(data) : await postReseller(data);
		responseAction(response);
  };

  const responseAction = (response) => {
    if (response.status) {
      const newItem = response.company;
      let array = [];
      if (modal.update) {
        array = items.map((item) => (item.id !== newItem.id ? item : newItem));
      } else {
        array = [...items, newItem];
        array.sort((a, b) => {
          return a.id - b.id;
        });
      }
      setItems(array);
    } else {
      setErrors(response.response.data.errors);
    }
  };

  useEffect(() => {
    getProfilescat().then((response) => {
      console.log();
      if (authUser.profile_id == 1) {
        getCompanies().then((resp) => {
          //setSelects({...selects,});
          setSelects({
            ...selects,
            companies: resp.companies,
            profiles: response.profiles,
          });
        });
      } else {
        setSelects({ ...selects, profiles: response.profiles });
      }
    });
  }, []);

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-warning">
          {modal.update ? "Editar " : "Agregar "}Revendedor
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              <div className="col-sm-12">
                <label className="form-label">Empresa:</label>
                <Input
                  name="name"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.name || ""}
                  invalid={
                    validation.touched.name && validation.errors.name
                      ? true
                      : false
                  }
                />
                {validation.touched.name && validation.errors.name && (
                  <FormFeedback type="invalid">
                    {validation.errors.name}
                  </FormFeedback>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6 mt-2">
                <label className="form-label">Nombre usuario:</label>
                <Input
                  name="user_name"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.user_name || ""}
                  invalid={
                    validation.touched.user_name && validation.errors.user_name
                      ? true
                      : false
                  }
                />
                {validation.touched.user_name &&
                  validation.errors.user_name && (
                    <FormFeedback type="invalid">
                      {validation.errors.user_name}
                    </FormFeedback>
                  )}
              </div>
              <div className="col-sm-6 mt-2">
                <label className="form-label">Email de usuario:</label>
                <Input
                  name="user_email"
                  type="email"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.user_email || ""}
                  invalid={
                    validation.touched.user_email &&
                    validation.errors.user_email
                      ? true
                      : false
                  }
                />
                {errors && (
                  <div className="form-text text-danger">
                    {errors.user_email && errors.user_email}
                  </div>
                )}
                {validation.touched.user_email &&
                  validation.errors.user_email && (
                    <FormFeedback type="invalid">
                      {validation.errors.user_email}
                    </FormFeedback>
                  )}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cancelar
            </Button>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
